// This file was automatically generated from appshared.newMessage.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appshared.newMessage');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.newMessage.messageDialog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8InlineFormContainer ebs-container-fluid"><div class="el8FieldSectionOverflow ebs-row"><div class="el8Wrap fl ebs-pull-left padl15 padt3"><a class="el8DialogLink premadeResponseTrigger">Auto-send Pre-Made Response<span class="el8DownArrowIcon"></span></a></div><ul class="el8ButtonContainer el8AlignRight ebs-text-right ebs-form-inline ebs-list-inline padh5"><li class="el8ButtonItem"><label class="checkMark alert"><input type="checkbox" class="options" name="leaveReqAct" / > Keep as Requiring Action</label></li><li><label class="checkMark alert"><input type="checkbox" class="options" name="markUrgent" ', (opt_data.isUrgent) ? 'checked disabled="disable"' : '', ' /> Mark as Urgent</label></li></ul></div><div class="el8TextareaWrap"><textarea type="text" name="replyBody" class="w100 ebs-form-control" rows="4"></textarea></div><div class="el8FieldSection ebs-form-group"><p id="toUsersExisting" class="el8Wrap mv5">Current thread recipients: <span class="name-list"></span></p><div class="el8TextareaWrap ebs-form-control"><div id="toUserReplySelected"></div><span id="toUserReplyInput" class=""></span></div></div><div class="el8DialogButtonContainer ebs-row"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" href="#" id="reply-send-btn" class="el8button el8PrimaryButton ebs-btn ebs-btn-primary">Send</button></li>', (opt_data.canSignOff) ? '<li class="el8ButtonItem"><button type="button" href="#" id="reply-send-signoff-btn" class="el8button el8SecondaryButton ebs-btn ebs-btn-default">Send and Sign Off</button></li>' : '', (opt_data.held) ? '<li class="el8ButtonItem"><button type="button" id="reply-discard-hold-btn" class="el8button el8SecondaryButton ebs-btn ebs-btn-default">Discard Hold</button></li>' : '<li class="el8ButtonItem"><button type="button" id="reply-cancel-btn" class="el8button el8SecondaryButton ebs-btn ebs-btn-default">Cancel</button></li>', '</ul><span class="tabcatcher" tabindex="0"></span></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.newMessage.referencedDocSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.showLink) ? 'RE: <a class="item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' + soy.$$escapeHtml(opt_data.summary) + '</a>' : 'RE: <span class="">' + soy.$$escapeHtml(opt_data.summary) + '</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appshared.newMessage.postDateFtue = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEText">Did you know you can post-date letters to patients and providers? <a target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/post-date-a-message-to-yourself-or-a-colleague" class="learn-more-trigger">Learn more</a><p></div><div class="el8FTUEBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};
